<template>
    <div class="packaging">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col :span="20">
                <el-col :span="24"
                        class="center">
                    <p class="head">{{articleContent.title}}</p>
                    <p class="text">{{articleContent.description}}</p>
                </el-col>
            </el-col>
        </el-row>
        <el-row type="flex"
                class="row-bg main"
                justify="center">
            <el-col :span="20">

                <div class="content"
                     v-html="articleContent.osArticleContent.content">
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
//import { queryproductdescbyid } from "@/api/productInfo";
import { mapGetters } from "vuex";
export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters(["activeIndex", "articleContent"])
    },
    mounted() {
        // if (this.$route.query.id) {
        //     this.$store.dispatch("ProductdescById", this.$route.query.id);
        // }
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.packaging {
    padding-bottom: 59px;
    background-color: #f5f6f7;
    .center {
        .head {
            margin-top: 60px;
            font-size: 20px;
            text-align: center;
        }
        .text {
            text-align: center;
            margin-top: 10px;
            line-height: 22px;
            color: #333;
            font-size: 14px;
        }
    }
    .main {
        margin-top: 30px;
        .el-col {
            background-color: #fff;
            .content {
                margin: 30px 60px;
                white-space: pre-line;
                word-wrap: break-word;
                word-break: break-all;
                p {
                    font-size: 14px;
                    color: #666;
                    margin-top: 12px;
                }
                p:nth-child(1),
                p:nth-child(3),
                p:nth-child(7) {
                    font-size: 16px;
                    margin-top: 30px;
                    font-weight: 600;
                    color: #000;
                }
                p:nth-last-child(1) {
                    margin-bottom: 40px;
                }
                .totop {
                    margin-top: 4px;
                }
                span {
                    display: inline-block;
                    width: 36px;
                    height: 3px;
                    background-color: #fabe00;
                    position: relative;
                    top: -6px;
                }
            }
        }
    }
}
</style>
